import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = [
    'showComponent',
    'addBtn',
    'contentTemplate',
    'voteType',
    'voteForm',
    'voteTitle',
    'contentWrapper',
    'voteCntComponent',
    'votableCnt',
    'checkedPriotyVote',
    'resultViewType',
    'voteType',
    'content',
    'votableCntUnlimited',
    'debateStartAt',
    'debateCloseAt',
    'votesItem',
    'inputPasswordModal',
    'inputPasswordModalError',
    'isSecretVoteCheckbox',
    'secretPasswordInput',
    'voteList',
    'secretVotePasswordInput',
    'secretPasswordInputMsg',
    'isSecretVoteInput',
    'isAnonymousCheckbox',
    'isAnonymousInput',
  ];

  static values = {
    logged: Number,
    group: Number,
    voteId: Number,
    boardId: Number,
    voteContentId: Number,
    datesTermStatus: String,
    isSuperAdmin: {
      type: Boolean,
      default: false,
    },
    isBoardManager: {
      type: Boolean,
      default: false,
    },
    selectedVoteId: {
      type: Number,
      default: 0,
    },
    selectedBoardId: {
      type: Number,
      default: 0,
    },
  };

  #minVoteCnt = 1;

  voteListTargetConnected() {
    const selectedVoteId = this.selectedVoteIdValue;
    const selectedBoardId = this.selectedBoardIdValue;
    if (selectedVoteId === 0 || selectedBoardId === 0) {
      return;
    }
    this.showCheckPasswordModal(selectedVoteId, selectedBoardId);
  }

  voteFormTargetConnected() {
    this.initDebatePeriod();
    this.initSecretPassword();
  }

  initDebatePeriod() {
    const status = this.datesTermStatusValue;
    const startAt = this.debateStartAtTarget;
    const closeAt = this.debateCloseAtTarget;
    if (this.isSuperAdminValue || this.isBoardManagerValue) {
      startAt.setAttribute('data-flatpickr-enable-value', true);
      closeAt.setAttribute('data-flatpickr-enable-value', true);
      return;
    }
    if (status === 'WAITING') {
      startAt.setAttribute('data-flatpickr-enable-value', true);
      closeAt.setAttribute('data-flatpickr-enable-value', true);
    } else if (status === 'RUNNING') {
      startAt.setAttribute('data-flatpickr-enable-value', false);
      closeAt.setAttribute('data-flatpickr-enable-value', true);
    } else if (status === 'ENDED') {
      startAt.setAttribute('data-flatpickr-enable-value', false);
      closeAt.setAttribute('data-flatpickr-enable-value', false);
    }
  }

  initSecretPassword() {
    if (!this.isSuperAdminValue) {
      return;
    }
    if (this.isSecretVoteCheckboxTarget.checked) {
      this.enableSecretPassword();
    } else {
      this.disableSecretPassword();
    }
  }

  votableCntUnlimitedTargetConnected() {
    if (this.votableCntUnlimitedTarget.checked) {
      this.unlimitedVotableCnt();
      this.votableCntTarget.value = 1;
    }
  }

  vote() {
    if (!this.isValidMaxVotedCnt()) {
      const msg = `투표는 최대 ${this.votableCntTarget.value}개 까지만 선택 수 있습니다. 투표를 다시 하시려면 기존 체크항목을 해제하고 다시 선택해주세요.`;
      window.$sendAlert(msg);
      return false;
    }
    if (this.getVotedCnt() < this.#minVoteCnt) {
      window.$sendAlert(`최소 ${this.#minVoteCnt}개를 선택해야 투표를 진행할 수 있습니다.`);
      return false;
    }

    const url = '/ajax/vote/content';
    const voteList = document.querySelectorAll('input[name=voteList]:checked');
    let voteArr = '';
    for (let i = 0; i < voteList.length; i++) {
      voteArr += voteList[i].value;
      if (i + 1 !== voteList.length) {
        voteArr += ',';
      }
    }
    const requestBody = {
      voteId: document.getElementById('vote_id').value,
      voteContentId: voteArr,
    };

    callApi(url, 'POST', requestBody)
      .then((responseBody) => {
        window.$reloadAndSendNotice(responseBody.msg);
      })
      .catch((err) => {
        window.$reloadAndSendAlert(err.msg);
      });
  }

  appendContent() {
    const tempWrapper = $(copyWrapper).clone();

    $(tempWrapper).find('.uploaded-attached-img').remove();

    $(tempWrapper).find('#voteImage0').val('');
    $(tempWrapper).find('#contentId0').val('');
    $(tempWrapper).find('#voteTitle0').val('');
    $(tempWrapper).find('#voteContent0').val('');

    // 기존 업로드 되어있는 파일 삭제
    $(tempWrapper).find('.attached-file-list').empty();

    $('#content_wrapper').append(tempWrapper);

    this.resetIndexOfContents();
  }

  resetIndexOfContents() {
    this.contentTemplateTargets.forEach((contentTemplateTarget, index) => {
      let voteImage = $(contentTemplateTarget).find("[id^='voteImage']");
      voteImage.attr('name', `voteContentDto[${index}].voteImage`);
      voteImage.attr('id', 'voteImage' + index);

      let voteImageLabel = $(contentTemplateTarget).find("[id^='voteImageLabel']");
      voteImageLabel.attr('for', 'voteImageLabel' + index);
      voteImageLabel.attr('id', 'voteImageLabel' + index);

      let imageBtn = $(contentTemplateTarget).find("[id^='imageBtn']");
      imageBtn.attr('data-attached-file-id-param', 'voteImage' + index);
      imageBtn.attr('data-attached-file-name-param', 'voteContentDto[' + index + '].voteImage');
      imageBtn.attr('id', 'imageBtn' + index);

      let voteTitle = $(contentTemplateTarget).find("[id^='voteTitle']");
      voteTitle.attr('name', 'voteContentDto[' + index + '].voteTitle');
      voteTitle.attr('id', 'voteTitle' + index);

      let voteContent = $(contentTemplateTarget).find("[id^='voteContent']");
      voteContent.attr('name', 'voteContentDto[' + index + '].voteContent');
      voteContent.attr('id', 'voteContent' + index);

      let voteContentId = $(contentTemplateTarget).find("[id^='contentId']");
      voteContentId.attr('name', 'voteContentDto[' + index + '].contentId');
      voteContentId.attr('id', 'contentId' + index);

      $(contentTemplateTarget)
        .find('h4')
        .text(index + 1);
    });
  }

  removeContent(e) {
    if (this.contentTemplateTargets.length > 1) {
      e.target.closest('.chk-contents').remove();
    }
    // 추가반영된 부분까지 추가
    if (this.votableCntTarget.value > this.contentTemplateTargets.length) {
      this.votableCntTarget.value = this.contentTemplateTargets.length;
    }

    this.resetIndexOfContents();
  }

  save() {
    if (!this.isValidSave()) {
      return;
    }

    let $this = this;
    const voteType = document.querySelector('input[name="voteType"]:checked').value;
    if (voteType === 'C') {
      //모든 게시물 클리어 후 찬성반대기타 추가
      this.contentWrapperTarget.innerHTML = '';
      const contentArr = ['찬성', '기타', '반대'];
      for (var i = 0; i < contentArr.length; i++) {
        $this.appendContent();
        document.getElementById('voteTitle' + i).value = contentArr[i];
        document.getElementById('voteContent' + i).value = contentArr[i];
      }
    } else if (this.votableCntUnlimitedTarget.checked) {
      this.votableCntTarget.value = -1;
    }

    this.voteFormTarget.submit();
  }

  isValidSave() {
    let isValid = true;

    if ($('#title').val() === '') {
      window.$sendAlert('제목을 입력하세요');
      isValid = isValid && false;
    }

    const contentTxt = $('#content_ifr').contents().find('body').text();
    const contentHtml = $('#content_ifr').contents().find('body').html();
    if (contentTxt === '' || contentHtml === '<p><br data-mce-bogus="1"></p>') {
      window.$sendAlert('내용을 입력하세요');
      isValid = isValid && false;
    }

    if ($('#debateStartAt').val() >= $('#debateCloseAt').val()) {
      window.$sendAlert('투표 시작일은 종료일 보다 앞서 있어야 합니다.');
      isValid = isValid && false;
    }

    if (!this.isValidSecretPassword()) {
      window.$sendAlert('비밀번호는 숫자 4~6자리로 생성해주세요.');
      isValid = isValid && false;
    }

    const voteType = document.querySelector('input[name="voteType"]:checked').value;
    if (!this.isValidVotableCnt(voteType)) {
      window.$sendAlert('투표가능 갯수를 확인해주세요.');
      isValid = isValid && false;
    }
    return isValid;
  }

  isValidVotableCnt(voteType) {
    if (voteType === 'C') {
      return true;
    }
    const isUnlimited = this.votableCntUnlimitedTarget.checked;
    if (isUnlimited) {
      return true;
    }
    const maxCnt = this.contentTemplateTargets.length;
    return !(this.votableCntTarget.value === '0' || this.votableCntTarget.value > maxCnt);
  }

  async cancel() {
    callApi('/ajax/vote/content', 'DELETE', { voteId: this.voteIdValue })
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$reloadAndSendAlert(err.msg);
      });
  }

  type() {
    const radio = this.voteTypeTargets;
    let value = '';

    for (var i = 0; i < radio.length; i++) {
      if (radio[i].checked) {
        value = radio[i].value;
      }
    }

    if (value == 'P') {
      this.showComponentTargets.forEach((k) => k.classList.remove('hidden'));
      this.votableCntTarget.value = '1';
    } else {
      this.showComponentTargets.forEach((k) => k.classList.add('hidden'));
      this.votableCntTarget.value = '1';
    }
  }

  isCheckable(e) {
    if (!e.target.checked) {
      return;
    }
    if (this.isValidMaxVotedCnt()) {
      return;
    }
    const msg = `투표는 최대 ${this.votableCntTarget.value}개 까지만 선택 수 있습니다. 투표를 다시 하시려면 기존 체크항목을 해제하고 다시 선택해주세요.`;
    window.$sendAlert(msg);
    e.target.checked = false;
  }

  isValidMaxVotedCnt() {
    const votedCnt = this.getVotedCnt();
    const voteType = this.voteTypeTarget.value;
    if (voteType === 'P') {
      const votableCnt = +this.votableCntTarget.value;
      if (votableCnt === -1) {
        return true;
      }
      return votedCnt <= votableCnt;
    }
    return true;
  }

  getVotedCnt() {
    return this.checkedPriotyVoteTargets.filter((vote) => vote.checked).length;
  }

  unlimitedVotableCnt() {
    this.votableCntTarget.readOnly = !this.votableCntTarget.readOnly;
    this.votableCntTarget.classList.toggle('!text-gray-500');
    this.votableCntTarget.classList.toggle('!bg-gray-200');
  }

  goDetail(evt) {
    const voteId = evt.params.id;
    const boardId = evt.params.boardId;

    if (this.isSuperAdminValue) {
      window.location.href = this.getVoteDetailUrl(voteId, boardId);
      return;
    }
    const isSecret = evt.params.isSecretVote;
    if (isSecret) {
      this.showCheckPasswordModal(voteId, boardId);
      return;
    }
    window.location.href = this.getVoteDetailUrl(voteId, boardId);
  }

  getVoteDetailUrl(voteId, boardId) {
    return `${window._spring.context_path}/vote/${boardId}/${voteId}`;
  }

  showCheckPasswordModal(voteId, boardId) {
    this.inputPasswordModalTarget.classList.remove('hidden');
    this.inputPasswordModalTarget.querySelector('form').setAttribute('data-vote-id-param', voteId);
    this.inputPasswordModalTarget.querySelector('form').setAttribute('data-vote-board-id-param', boardId);
  }

  checkPassword(evt) {
    evt.preventDefault();
    const form = evt.target;
    const voteId = evt.params.id;
    const boardId = evt.params.boardId;
    const password = form.querySelector('input[name="secret-vote-password"]').value;
    const requestBody = { voteId, password };
    fetch(_spring['context_path'] + '/ajax/vote/check-password', {
      method: 'POST',
      credentials: 'include',
      headers: Object.assign({}, _csrf, {
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          this.inputPasswordModalErrorTarget.classList.add('hidden');
          this.inputPasswordModalErrorTarget.innerText = '';
          this.secretVotePasswordInputTarget.classList.remove('!border-red-600');
          location.assign(this.getVoteDetailUrl(voteId, boardId));
        } else if (data.success === false) {
          this.secretVotePasswordInputTarget.classList.add('!border-red-600');
          this.inputPasswordModalErrorTarget.classList.remove('hidden');
          this.inputPasswordModalErrorTarget.innerText = '비밀번호가 틀렸습니다';
        }
      })
      .catch(() => {
        this.secretVotePasswordInputTarget.classList.add('!border-red-600');
        this.inputPasswordModalErrorTarget.classList.remove('hidden');
        this.inputPasswordModalError.innerText = '비밀번호 체크에 실패했습니다. 관리자에게 문의해주세요.';
      });
  }

  cancelCheckPassword() {
    this.inputPasswordModalTarget.classList.add('hidden');
  }

  disableSecretPassword() {
    this.secretPasswordInputTarget.disabled = true;
    this.secretPasswordInputTarget.readOnly = true;
    this.secretPasswordInputTarget.classList.add('!bg-gray-200');
    this.secretPasswordInputTarget.classList.add('!text-gray-500');
    this.secretPasswordInputMsgTarget.classList.add('hidden');
  }

  enableSecretPassword() {
    this.secretPasswordInputTarget.disabled = false;
    this.secretPasswordInputTarget.readOnly = false;
    this.secretPasswordInputTarget.classList.remove('!bg-gray-200');
    this.secretPasswordInputTarget.classList.remove('!text-gray-500');
    this.secretPasswordInputMsgTarget.classList.remove('hidden');
  }

  isSecretVoteCheckboxHandler() {
    if (this.isSecretVoteCheckboxTarget.checked) {
      this.isSecretVoteInputTarget.value = true;
      this.enableSecretPassword();
    } else {
      this.isSecretVoteInputTarget.value = false;
      this.disableSecretPassword();
    }
  }

  secretPasswordInputChangeHandler() {
    if (!this.isValidSecretPassword()) {
      this.secretPasswordInputMsgTarget.classList.add('!text-red-700');
      this.secretPasswordInputMsgTarget.classList.remove('!text-primary-700');
      return;
    }
    this.secretPasswordInputMsgTarget.classList.remove('!text-red-700');
    this.secretPasswordInputMsgTarget.classList.add('!text-primary-700');
  }

  isValidSecretPassword() {
    if (!this.isSuperAdminValue) {
      return true;
    }
    const password = this.secretPasswordInputTarget.value;
    if (!this.isSecretVoteCheckboxTarget.checked) {
      return true;
    }
    if (password.length < 4 || password.length > 6 || !password.match('^[0-9]*$')) {
      return false;
    }
    return true;
  }

  disableIsSecret() {
    this.isSecretVoteCheckboxTarget.readOnly = true;
    this.isSecretVoteCheckboxTarget.disabled = true;
  }

  isAnonymousCheckboxHandler(e) {
    if (e.target.checked === true) {
      this.isAnonymousInputTarget.value = true;
    } else {
      this.isAnonymousInputTarget.value = false;
    }
  }
}
